var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOwner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 36,
    viewBox: "0 0 28 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8905 22.8476C17.7849 21.832 17.9308 20.8074 18.096 20.0528C18.7517 19.3601 19.313 18.3292 19.8916 16.6966C20.7631 16.3769 21.6482 15.6389 22.0588 13.8206C22.2482 12.983 21.9193 12.2085 21.3513 11.6509C21.763 10.2689 23.3836 3.86603 18.5148 2.56768C16.8958 0.543832 15.4788 0.624701 13.05 0.867582C11.8418 0.988304 11.6702 1.2452 10.7428 1.11046C9.67915 0.955765 8.81625 0.632972 8.55683 0.503226C8.40739 0.428305 7.00473 1.67306 6.61378 2.68915C5.37579 5.90799 5.70843 8.11558 6.02309 9.78526C6.01256 9.95623 5.99855 10.1266 5.99855 10.2995L6.28716 11.5226C6.28771 11.5352 6.28689 11.5473 6.28743 11.5599C5.65989 12.1225 5.28152 12.9361 5.48141 13.8207C5.89225 15.6399 6.77798 16.3776 7.64963 16.6971C8.22788 18.3284 8.78863 19.3588 9.44393 20.0516C9.60922 20.8063 9.75524 21.8314 9.64969 22.8478C9.20747 27.1047 0.25 24.8624 0.25 32.337C0.25 33.4897 4.11272 35.5001 13.77 35.5001C23.4272 35.5001 27.29 33.4897 27.29 32.337C27.2901 24.8623 18.3326 27.1046 17.8905 22.8476Z",
    fill: "#F75586"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwner);
export default __webpack_public_path__ + "static/media/owner.15fe140d29d25c36d80a66439405fde8.svg";
export { ForwardRef as ReactComponent };